"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regex = require("@slyk/regex");

/**
 * Module dependencies.
 */

/**
 * Export `dashboardRoutes`.
 */
var _default = {
  acceptInvite: {
    base: '/dashboard/sign-up/accept-invite/',
    email: '/dashboard/sign-up/accept-invite/email'
  },
  account: {
    details: {
      base: '/dashboard/account/details',
      changePassword: '/dashboard/account/details/change-password',
      pickFromLibrary: '/dashboard/account/details/pick-from-library'
    },
    notifications: '/dashboard/account/notifications'
  },
  addFunds: {
    base: '/dashboard/add-funds',
    manualPayment: {
      base: '/dashboard/add-funds/manual-payment',
      success: '/dashboard/add-funds/manual-payment-success'
    },
    other: {
      base: '/dashboard/add-funds/other',
      success: '/dashboard/add-funds/other-success'
    },
    registerDeposit: {
      base: '/dashboard/add-funds/register-deposit',
      confirm: '/dashboard/add-funds/register-deposit-confirm',
      success: '/dashboard/add-funds/register-deposit-success'
    },
    rewardTask: {
      base: '/dashboard/add-funds/reward-task',
      success: '/dashboard/add-funds/reward-task-success'
    }
  },
  balance: '/dashboard/wallets/:id/balance/:type',
  billing: '/dashboard/billing',
  growthTools: {
    base: '/dashboard/growth-tools',
    marketingRewards: {
      add: {
        base: '/dashboard/growth-tools/marketing-rewards/add',
        form: '/dashboard/growth-tools/marketing-rewards/add/:type',
        pickFromLibrary: '/dashboard/growth-tools/marketing-rewards/add/:type/pick-from-library'
      },
      base: '/dashboard/growth-tools/marketing-rewards',
      edit: {
        base: "/dashboard/growth-tools/marketing-rewards/:id(".concat(_regex.uuid, ")/edit"),
        pickFromLibrary: "/dashboard/growth-tools/marketing-rewards/:id(".concat(_regex.uuid, ")/edit/pick-from-library")
      }
    },
    referralRewards: '/dashboard/growth-tools/referral-rewards',
    rewardSetup: '/dashboard/growth-tools/reward-setup'
  },
  integrationCallbacks: {
    coinbase: '/dashboard/integration-callbacks/coinbase'
  },
  orders: {
    base: '/dashboard/orders',
    cancelOrder: "/dashboard/orders/:id(".concat(_regex.uuid, ")/cancel"),
    capturePayment: "/dashboard/orders/:id(".concat(_regex.uuid, ")/capture-payment"),
    completeOrder: "/dashboard/orders/:id(".concat(_regex.uuid, ")/complete"),
    editShippingAddress: "/dashboard/orders/:id(".concat(_regex.uuid, ")/shipping-address/edit"),
    fulfillProducts: "/dashboard/orders/:id(".concat(_regex.uuid, ")/fulfill-products"),
    orderDetails: "/dashboard/orders/:id(".concat(_regex.uuid, ")"),
    refundPayment: "/dashboard/orders/:id(".concat(_regex.uuid, ")/refund-payment")
  },
  overview: '/dashboard',
  products: {
    addOption: '/dashboard/catalog/options/add/:productType',
    addProduct: {
      base: '/dashboard/catalog/items/add',
      form: '/dashboard/catalog/items/add/:type',
      pickFromLibrary: '/dashboard/catalog/items/add/:type/pick-from-library'
    },
    base: '/dashboard/catalog',
    categories: {
      add: {
        base: '/dashboard/catalog/categories/add',
        pickFromLibrary: '/dashboard/catalog/categories/add/pick-from-library'
      },
      base: '/dashboard/catalog/categories',
      edit: {
        base: "/dashboard/catalog/categories/:id(".concat(_regex.uuid, ")/edit"),
        pickFromLibrary: "/dashboard/catalog/categories/:id(".concat(_regex.uuid, ")/edit/pick-from-library")
      }
    },
    duplicateProduct: "/dashboard/catalog/items/:id(".concat(_regex.uuid, ")/duplicate"),
    editOption: "/dashboard/catalog/options/:id(".concat(_regex.uuid, ")/edit"),
    editProduct: {
      base: "/dashboard/catalog/items/:id(".concat(_regex.uuid, ")/edit"),
      duplicate: "/dashboard/catalog/items/:id(".concat(_regex.uuid, ")/edit/duplicate"),
      pickFromLibrary: "/dashboard/catalog/items/:id(".concat(_regex.uuid, ")/edit/pick-from-library")
    },
    items: '/dashboard/catalog/items',
    options: '/dashboard/catalog/options'
  },
  recoverPassword: '/dashboard/recover-password',
  recoverPasswordSuccess: '/dashboard/recover-password-success',
  resendPayspaceConfirmation: {
    base: '/dashboard/resend-payspace-confirmation',
    success: '/dashboard/resend-payspace-confirmation/success'
  },
  rewardAssetSetup: {
    base: '/dashboard/reward-asset-setup',
    confirm: '/dashboard/reward-asset-setup/confirm',
    customAsset: '/dashboard/reward-asset-setup/custom-asset',
    noRate: '/dashboard/reward-asset-setup/no-rate',
    rate: '/dashboard/reward-asset-setup/rate'
  },
  settings: {
    apiKeys: '/dashboard/settings/api-keys',
    appearance: {
      base: '/dashboard/settings/appearance',
      homeHighlights: {
        addCta: '/dashboard/settings/appearance/home-highlights/add',
        base: '/dashboard/settings/appearance/home-highlights',
        editCta: "/dashboard/settings/appearance/home-highlights/:id(".concat(_regex.uuid, ")/edit")
      },
      media: {
        base: '/dashboard/settings/appearance/media',
        pickFromLibrary: {
          image: '/dashboard/settings/appearance/media/image/pick-from-library',
          logo: '/dashboard/settings/appearance/media/logo/pick-from-library'
        }
      }
    },
    base: '/dashboard/settings',
    communityAndSupport: '/dashboard/settings/community-and-support',
    currenciesAndAssets: {
      addCustomAsset: {
        base: '/dashboard/settings/currencies-and-assets/assets/add-custom',
        pickFromLibrary: '/dashboard/settings/currencies-and-assets/assets/add-custom/pick-from-library'
      },
      addRate: '/dashboard/settings/currencies-and-assets/rates/add',
      assets: '/dashboard/settings/currencies-and-assets',
      editCustomAsset: {
        base: '/dashboard/settings/currencies-and-assets/assets/:code/edit',
        pickFromLibrary: '/dashboard/settings/currencies-and-assets/assets/:code/edit/pick-from-library'
      },
      editRate: '/dashboard/settings/currencies-and-assets/rates/:baseAssetCode/:quoteAssetCode/edit',
      rates: '/dashboard/settings/currencies-and-assets/rates'
    },
    general: '/dashboard/settings/general',
    paymentMethods: {
      addBankAccount: '/dashboard/settings/payment-methods/bank-accounts/add',
      base: '/dashboard/settings/payment-methods',
      configure: '/dashboard/settings/payment-methods/:slug/configure',
      connect: '/dashboard/settings/payment-methods/:slug/connect',
      editBankAccount: '/dashboard/settings/payment-methods/bank-accounts/:id/edit',
      more: '/dashboard/settings/payment-methods/more'
    },
    store: {
      base: '/dashboard/settings/store',
      pickup: '/dashboard/settings/store/pickup',
      shipping: '/dashboard/settings/store/shipping',
      taxRates: {
        add: '/dashboard/settings/store/taxes/tax-rates/add',
        base: '/dashboard/settings/store/taxes/tax-rates',
        edit: '/dashboard/settings/store/taxes/tax-rates/:id/edit'
      },
      taxes: '/dashboard/settings/store/taxes'
    },
    teamAndRoles: {
      base: '/dashboard/settings/team-and-roles',
      manageTeam: {
        addMember: '/dashboard/settings/team-and-roles/manage-team/add-member',
        base: '/dashboard/settings/team-and-roles/manage-team',
        transferOwnership: '/dashboard/settings/team-and-roles/manage-team/transfer-ownership'
      },
      notifications: '/dashboard/settings/team-and-roles/notifications'
    }
  },
  signIn: '/dashboard/sign-in',
  signInEmail: '/dashboard/sign-in/email',
  storefront: {
    categories: '/dashboard/storefront/categories',
    itemEdit: "/dashboard/storefront/item/:id(".concat(_regex.uuid, ")/edit"),
    items: '/dashboard/storefront',
    itemsAdd: '/dashboard/storefront/items/add'
  },
  transactionDetails: "/dashboard/transaction/:id(".concat(_regex.uuid, ")"),
  users: {
    approvalRequests: '/dashboard/users/approval-requests',
    base: '/dashboard/users',
    invite: '/dashboard/users/invite',
    userDetails: {
      advanced: "/dashboard/users/:id(".concat(_regex.uuid, ")/advanced"),
      base: "/dashboard/users/:id(".concat(_regex.uuid, ")"),
      identity: "/dashboard/users/:id(".concat(_regex.uuid, ")/identity"),
      transactions: "/dashboard/users/:id(".concat(_regex.uuid, ")/transactions")
    }
  },
  wallet: {
    activity: '/dashboard/wallet/activity',
    base: '/dashboard/wallet',
    deposits: '/dashboard/wallet/manual-deposits',
    withdrawals: '/dashboard/wallet/withdrawals'
  },
  wallets: {
    balance: "/dashboard/wallets/:id(".concat(_regex.uuid, ")/balance/:type"),
    overview: "/dashboard/wallets/:id(".concat(_regex.uuid, ")"),
    transactions: "/dashboard/wallets/:id(".concat(_regex.uuid, ")/transactions"),
    unassignedWallets: '/dashboard/wallets/unassigned'
  },
  wizard: {
    autoComplete: '/dashboard/wizard/auto-complete',
    base: '/dashboard/wizard',
    confirmPayspace: '/dashboard/wizard/confirm',
    confirmPayspaceSSO: '/dashboard/wizard/confirm-sso',
    logo: {
      base: '/dashboard/wizard/logo',
      library: '/dashboard/wizard/logo/library'
    },
    paymentMethods: {
      bankAccount: {
        add: '/dashboard/wizard/payment-methods/:slug/bank-account/add',
        base: '/dashboard/wizard/payment-methods/:slug/bank-account',
        edit: '/dashboard/wizard/payment-methods/:slug/bank-account/edit'
      },
      base: '/dashboard/wizard/payment-methods',
      configure: '/dashboard/wizard/payment-methods/:slug/configure'
    },
    products: {
      addConsultation: {
        base: '/dashboard/wizard/products/add/consultation',
        library: '/dashboard/wizard/products/add/consultation/library'
      },
      addProduct: {
        base: '/dashboard/wizard/products/add',
        form: {
          base: '/dashboard/wizard/products/add/:type',
          currency: '/dashboard/wizard/products/add/:type/currency',
          library: '/dashboard/wizard/products/add/:type/library'
        }
      },
      base: '/dashboard/wizard/products',
      catalog: '/dashboard/wizard/products/catalog',
      editProduct: {
        base: '/dashboard/wizard/products/edit',
        form: {
          base: '/dashboard/wizard/products/edit/:id',
          library: '/dashboard/wizard/products/edit/:id/library'
        }
      }
    },
    reward: '/dashboard/wizard/reward',
    share: '/dashboard/wizard/share',
    signupMode: '/dashboard/wizard/signup-mode',
    story: {
      base: '/dashboard/wizard/story',
      library: '/dashboard/wizard/story/library'
    }
  }
};
exports["default"] = _default;